import React from 'react';
import PopupAction from 'components/Misc/PopupActions/components/PopupAction';
import { Action } from 'helpers';
import { Divider } from '@mui/material';

function HotspotManagementPopup({ object, level, onClose }) {
    return (
        <React.Fragment>
            <PopupAction
                action={Action.Edit}
                object={object}
                level={level}
                showLabel={true}
                onActionHandled={onClose}
            />
            <Divider />
            <PopupAction
                action={Action.Delete}
                object={object}
                level={level}
                showLabel={true}
                onActionHandled={onClose}
            />
        </React.Fragment>
    );
}

export { HotspotManagementPopup };
